import { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../../firebase';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';

const initialServices = [
  {
    id: 'kat-karsiligi',
    icon: 'ri-building-4-line',
    title: 'Kat Karşılığı İnşaat',
    image: '/yapsat-site-5.png', // Premium Site
    description: 'KARE YAPI olarak, arsa sahiplerine en kârlı, güvenilir ve modern yaşam alanlarını sunmak için kat karşılığı inşaat projeleri üretiyoruz. Arsanızın konumuna, imar durumuna ve çevresel dinamiklere en uygun mimari projeyi titizlikle hazırlıyor, projelendirmeden anahtar teslime kadar tüm inisiyatifi ve finansal yükü üstleniyoruz. Kaliteden ödün vermeden, güncel deprem yönetmeliklerine %100 uygun, estetik ve sağlam binalar inşa ederek, arsanızın değerine değer katıyoruz.'
  },
  {
    id: 'kentsel-donusum',
    icon: 'ri-home-heart-line',
    title: 'Kentsel Dönüşüm',
    image: '/yapsat-realistic-1.png', // Modern Butik Apartman
    description: 'Riskli binalarınızı, aileniz ve geleceğiniz için güvenli, modern ve yüksek standartlı yaşam alanlarına dönüştürüyoruz. Kentsel dönüşüm sürecindeki tüm yasal prosedürleri, ruhsat alım işlemlerini ve projelendirmeyi sizin adınıza hızlıca tamamlıyoruz. Sadece bir bina yenilemekle kalmıyor; otoparklı, peyzajlı, yüksek yalıtımlı ve prestijli yapılar ortaya çıkararak yaşam kalitenizi zirveye taşıyoruz. Süreci en şeffaf şekilde yürüterek mağduriyete yer bırakmıyoruz.'
  },
  {
    id: 'taahhut-proje',
    icon: 'ri-tools-line',
    title: 'Taahhüt ve Güçlendirme',
    image: '/tk-const-new-1.png', // Şantiye İmalatı
    description: 'Deneyimli mühendis ve mimar kadromuzla, kamu ve özel sektör projelerinde ana yüklenici olarak taahhüt hizmetleri veriyoruz. Konut komplekslerinden ticari alanlara kadar geniş bir yelpazede üstlendiğimiz projeleri; iş güvenliği kurallarından taviz vermeden, taahhüt edilen bütçe sınırları içinde ve tam zamanında teslim ediyoruz. Aynı zamanda mevcut yapılarınızın sismik performans analizlerini yaparak modern donatılarla depreme karşı kesin güçlendirme çözümleri sunuyoruz.'
  },
  {
    id: 'mimari-muhendislik',
    icon: 'ri-compasses-2-line',
    title: 'Mimari ve Mühendislik Tasarımı',
    image: '/tk-int-ref-1.png', // İç Mimari Mutfak
    description: 'İnşaat öncesi asıl katma değerin tasarımda olduğuna inanıyoruz. KARE YAPI tasarım ofisinde; estetik, fonksiyonellik ve enerji verimliliğini merkeze alan yenilikçi konseptler üretiyoruz. Statik, mimari, mekanik ve elektrik projelerini bütünleşik bir mühendislik yaklaşımıyla çözüyor, güncel inşaat teknolojileri kullanarak hata payını sıfıra indiriyoruz. Hayalinizdeki yapıyı önce kağıt üzerinde kusursuzca var ediyoruz.'
  },
  {
    id: 'anahtar-teslim',
    icon: 'ri-key-2-line',
    title: 'Anahtar Teslim Projeler',
    image: '/premium-project-block.png', // Prestij Blok
    description: '\'Siz hayal edin, biz teslim edelim\' prensibiyle, projenin ilk saha hafriyatından, evinize gireceğiniz o son saniyeye kadar tüm inşaat ve ince işçilik süreçlerini tek elden yönetiyoruz. Altyapı, temel atma, kaba inşaat, elektrik-su tesisatları, akıllı ev sistemleri, parke, seramik ve peyzaj... Bütünleşik bir kalite kontrol mekanizması ile sürdürülen projelerimizde, size sadece anahtarınızı alıp yeni ve kusursuz bir yaşama adım atmak kalıyor.'
  },
  {
    id: 'yatirim-danismanlik',
    icon: 'ri-line-chart-line',
    title: 'Gayrimenkul Yatırım Danışmanlığı',
    image: '/premium-project-v6.png', // Lüks Teras / Konut
    description: 'Piyasanın dinamiklerini yakından takip eden uzman kadromuzla, gayrimenkul yatırımlarınızı en yüksek getiriyle buluşturuyoruz. Arazi geliştirme, arsa alım-satımı, fizibilite çalışmaları ve konut projelerinde yatırım analizi yaparak sizi doğru lokasyona ve kârlı projelere yönlendiriyoruz. KARE YAPI\'nın yıllara dayanan bölgesel hakimiyeti sayesinde, birikimlerinizi riskten uzak, sağlam ve hızla değer kazanan yapılara dönüştürüyoruz.'
  }
];

export default function ServicesPage() {
  const [servicesList, setServicesList] = useState(initialServices);

  useEffect(() => {
    window.scrollTo(0, 0);
    
    const unsub = onSnapshot(doc(db, 'pages', 'services'), (docSnap) => {
      if (docSnap.exists() && docSnap.data().items && docSnap.data().items.length === 6) {
        const dbItems = docSnap.data().items;
        // If the ID is a number, it's the corrupted CMS data (missing description/icon).
        // Fall back to initial robust data until the Admin saves the correct schema.
        if (typeof dbItems[0].id === 'number') {
          setServicesList(initialServices);
        } else {
          setServicesList(dbItems);
        }
      }
    });

    return () => unsub();
  }, []);

  return (
    <div className="min-h-screen bg-white selection:bg-red-500 selection:text-white">
      <Navbar />

      {/* Hero Section */}
      <section className="relative h-[60vh] min-h-[500px] flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0">
          <img 
            src="/tk-const-new-2.png" 
            alt="KARE YAPI Kurumsal Hizmetler" 
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/60 to-transparent"></div>
        </div>
        
        <div className="relative z-10 max-w-7xl mx-auto px-4 w-full pt-20">
          <motion.div 
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="max-w-3xl text-white"
          >
            <nav className="text-sm font-medium mb-6 flex items-center gap-2 text-gray-300">
              <Link to="/" className="hover:text-red-400 transition-colors">Ana Sayfa</Link>
              <span>/</span>
              <span className="text-white">Hizmetlerimiz</span>
            </nav>
            <h1 className="text-5xl md:text-7xl font-bold tracking-tight mb-6" style={{ fontFamily: 'Raleway, sans-serif' }}>
              Projelerinize <br className="hidden md:block"/> Değer Katıyoruz
            </h1>
            <p className="text-xl text-gray-200 leading-relaxed font-light border-l-4 border-red-600 pl-4">
              Modern mimari anlayışımız, güçlü mühendislik altyapımız ve yılların getirdiği tecrübe ile geleceğin güvenli yaşam alanlarını inşa ediyoruz.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Ultra Premium Zig-Zag Services Section */}
      <section className="pt-24 pb-12 bg-white">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-20">
            <span className="text-red-600 font-bold tracking-widest text-sm uppercase mb-3 block">Uzmanlık Alanlarımız</span>
            <h2 className="text-4xl md:text-5xl font-bold text-slate-900" style={{ fontFamily: 'Raleway, sans-serif' }}>
              Geleceği İnşa Eden Hizmetler
            </h2>
          </div>
        </div>

        <div className="flex flex-col">
          {servicesList.map((service, index) => {
            const isEven = index % 2 === 0;
            const number = String(index + 1).padStart(2, '0');
            
            return (
              <motion.div 
                key={service.id}
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-100px" }}
                transition={{ duration: 0.8 }}
                className={`flex flex-col md:flex-row items-center min-h-[60vh] md:min-h-[70vh] border-b border-gray-100 last:border-0 ${isEven ? 'bg-white' : 'bg-gray-50'}`}
              >
                {/* Image Half */}
                <div className={`w-full md:w-1/2 h-[50vh] md:h-full relative overflow-hidden ${!isEven ? 'md:order-2' : ''}`}>
                  <motion.div 
                    whileHover={{ scale: 1.05 }} 
                    transition={{ duration: 1.5, ease: "easeOut" }}
                    className="w-full h-full"
                  >
                    <img 
                      src={service.image} 
                      alt={service.title} 
                      className="w-full h-full object-cover"
                    />
                    {/* Subtle Overlay */}
                    <div className="absolute inset-0 bg-black/10 transition-opacity hover:opacity-0"></div>
                  </motion.div>
                </div>

                {/* Text Half */}
                <div className={`w-full md:w-1/2 p-8 md:p-16 lg:p-24 relative flex flex-col justify-center ${!isEven ? 'md:order-1' : ''}`}>
                  {/* Huge Number Watermark */}
                  <div className="absolute top-10 left-10 lg:left-24 text-[150px] font-black text-slate-100 leading-none select-none z-0">
                    {number}
                  </div>
                  
                  <div className="relative z-10">
                    <div className="w-16 h-16 bg-red-600 text-white rounded-2xl flex items-center justify-center text-3xl mb-8 shadow-lg shadow-red-600/30">
                      <i className={service.icon}></i>
                    </div>
                    
                    <h3 className="text-3xl md:text-4xl font-bold text-slate-800 mb-6 tracking-tight" style={{ fontFamily: 'Raleway, sans-serif' }}>
                      {service.title}
                    </h3>
                    
                    <div className="w-12 h-1 bg-gradient-to-r from-red-600 to-red-400 mb-8 rounded-full"></div>
                    
                    <p className="text-slate-600 leading-relaxed text-lg text-justify md:text-left">
                      {service.description}
                    </p>
                  </div>
                </div>
              </motion.div>
            );
          })}
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-24 bg-slate-900 relative overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute transform -rotate-45 -right-1/4 -top-1/4 w-[150%] h-[150%] bg-gradient-to-b from-transparent via-white to-transparent opacity-20"></div>
          <div className="absolute bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] inset-0"></div>
        </div>
        
        <div className="max-w-4xl mx-auto px-4 relative z-10 text-center">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6" style={{ fontFamily: 'Raleway, sans-serif' }}>
            Arsanız Var ve Değerlendirmek mi İstiyorsunuz?
          </h2>
          <p className="text-xl text-gray-300 mb-10 font-light">
            KARE YAPI'nın uzman kadrosu ile iletişime geçin, arsanıza en uygun ve kârlı projeyi birlikte geliştirelim. Profesyonel analiz ve ücretsiz ekspertiz için sizi bekliyoruz.
          </p>
          <Link 
            to="/contact" 
            className="inline-flex items-center gap-3 bg-red-600 hover:bg-red-700 text-white px-8 py-4 rounded-full font-bold text-lg transition-all shadow-xl shadow-red-600/30 hover:-translate-y-1"
          >
            Hemen İletişime Geçin
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
}
